import React, { memo } from "react";
import styles from "./TabSelector.module.scss";

export type Tab = {
	id: number;
	title: string;
	icon?: React.ReactNode;
	onClick: () => void;
	count?: number;
	disabled?: boolean;
};

type Props = {
	tabs: Tab[];
	selectedTab: number;
	theme?: string;
};

const TabSelector: React.FC<Props> = memo((props: Props) => {
	const { tabs, selectedTab, theme } = props;

	return (
		<div className={`${styles.container} ${theme ? styles[theme] : ""} `}>
			{tabs.map((tab, index) => (
				<button key={tab.id} role="tab" disabled={tab.disabled ?? false} className={`standardButton ${styles.tab} ${tab.id === selectedTab ? styles.tabSelected : ""}`} onClick={tab.onClick}>
					{tab.icon}
					{tab.title}
					{tab.count !== undefined && <span className={styles.tabBadge}>{tab.count}</span>}
				</button>
			))}
		</div>
	);
});

export default TabSelector;
